import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { scaleLinear } from 'd3';
import { memo, useMemo } from 'react';
import generateJGraphData from '../../../data/data1d/Spectrum1D/generateJGraphData';
import { useChartData } from '../../context/ChartContext';
import { useActiveSpectrumRangesViewState } from '../../hooks/useActiveSpectrumRangesViewState';
import { usePanelPreferences } from '../../hooks/usePanelPreferences';
import useSpectrum from '../../hooks/useSpectrum';
import { JGraphContextProvider } from './JGraphContext';
import { JGraphVerticalAxis } from './JGraphVerticalAxis';
import JCouplingLinks from './JsCouplingLinks';
import JsCouplings from './JsCouplings';
const marginTop = 50;
function InnerJGraph(props) {
    const { signals, links } = props;
    return (_jsxs("g", { className: "j-graph", transform: `translate(0,${marginTop})`, children: [_jsx(JGraphVerticalAxis, {}), _jsx(JCouplingLinks, { links: links }), _jsx(JsCouplings, { signals: signals })] }));
}
const MemoizedJGraph = memo(InnerJGraph);
export default function JGraph() {
    const { height, view: { spectra: { activeTab }, }, } = useChartData();
    const spectrum = useSpectrum();
    const { showJGraph } = useActiveSpectrumRangesViewState();
    const rangesPreferences = usePanelPreferences('ranges', activeTab);
    const graphHeight = height / 4;
    const { signals, jCouplingMax: maxValue, links, } = useMemo(() => generateJGraphData(spectrum?.ranges.values, rangesPreferences.jGraphTolerance) || {
        signals: [],
        jCouplingMax: 0,
        links: [],
    }, [rangesPreferences.jGraphTolerance, spectrum?.ranges.values]);
    const scaleY = useMemo(() => {
        const maxRange = maxValue + maxValue * 0.1;
        return scaleLinear().range([graphHeight, 0]).domain([0, maxRange]);
    }, [graphHeight, maxValue]);
    const JGraphState = useMemo(() => {
        return { scaleY, height: graphHeight, maxValue };
    }, [graphHeight, scaleY, maxValue]);
    if (!showJGraph || !spectrum?.display?.isVisible)
        return null;
    return (_jsx(JGraphContextProvider, { value: JGraphState, children: _jsx(MemoizedJGraph, { signals: signals, links: links }) }));
}
